<template>
    <div v-if="type == 'text'" :class='theme' class="section-text--container">
        <div v-if="collapse" @click="collapseSection" class="section-text__header js-text-section">
            <i :class="icon_classes"></i>
            <p class="body-1"><slot name='heading'></slot></p>
        </div>
        <div v-else class="section-text__header">
            <p class="body-1"><slot name='heading'></slot></p>
        </div>
        <p :class="body_classes">
            <slot name='body'></slot>
        </p>
    </div>

    <section v-else-if="type == 'accordion'" :class='theme' class="accordion__section">
        <div @click="accordionCollapse" class="section__header js-accordion">
            <h4><slot name='heading'></slot></h4>
            <i :class="icon_classes"></i>
        </div>
        <div :class="body_classes">
            <slot name='body'></slot>
        </div>
    </section>

    <fieldset v-else-if="type == 'fieldset'" :class='theme' class="form__fieldset">
      <div v-if="collapse" @click="collapseSection" class="form__fieldset-header">
         <h4><slot name='heading'></slot></h4>
         <i :class="icon_classes"></i>
      </div>
      <div v-else class="form__fieldset-header">
         <h4><slot name='heading'></slot></h4>
      </div>
      <div class="form__fieldset-body" :class="body_classes">
         <slot name="body"></slot>
      </div>
    </fieldset>

    <section v-else :class='theme' class="section--container">
        <div v-if="!collapse" :class="classes" class="section__header">
            <h4><slot name='heading'></slot></h4>
        </div>
        <div v-else @click="collapseSection" :class="classes" class="section__header js-section">
            <h4><slot name='heading'></slot></h4>
            <i :class="icon_classes"></i>
        </div>
        <div :class="body_classes">
            <slot name='body'></slot>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
var eventHub = new Vue()

export default {
   data() {
      return {
         icon: {
            shape: this.type == 'text' ? 'circle' : 'square',
            plus: true
         },
         open: this.collapse || this.type == 'accordion' ? false : true
      }
   },
   props: {
      type: { type: String, default: null},
      collapse: { type: Boolean, default: false },
      color: { type: String, default: 'blue' }
   },
   methods: {
      collapseSection() {
         this.icon.plus = !this.icon.plus
         this.open = !this.open
      },
      accordionCollapse(){
         let closeMe = this.open == true ? true : false
         eventHub.$emit('closeAll')
         closeMe ? this.collapseSection : (this.icon.plus = false, this.open = true)
      },
   },
   computed: {
      body_classes() {
         const { open, type } = this
         let openClass = open ? 'open' : 'close'
         return [ 
            ...(type == 'text' ? ['section-text__body', 'body-1'] : ['section__body']),
            openClass
         ]
      },
      icon_classes () {
         const { icon, type } = this
         let sym = icon.plus ? 'plus' : 'minus'
         return [
            type == 'text' ? 'fas' : 'far',
            `fa-${sym}-${icon.shape}`
         ]
      },
      classes () {
         const { color } = this
            
         return [
            ...(color ? [`${color}`] : null),
         ]
      },
      theme() {
         return [
            this.$tiscPlugin.theme
         ]
      }
   },
   mounted: function () { 
      eventHub.$on('closeAll', () => { 
         this.icon.plus = true
         this.open = false
      })
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/section.scss';
</style>